<div
  class="dialog-container"
  [ngClass]="modalState?.showEditPax ? 'dialog-showpax' : ''"
>
  <div class="dialog-header">
    <div class="dialog-header-title">
      {{ currentTitle }}
    </div>
    <div class="dialog-header-cross" (click)="cancel_clicked()">
      <img [src]="images.CROSS" class="img-20" alt="close"/>
    </div>
  </div>

  <div class="dialog-form">
    <div class="confirm-class">
      <div class="order-content-rc" id="new-order-details-id">
        <div class="mt-10 mb-10 mr-25 ml-25">
          <!-- Order Type -->
          <div class="grid-row" *ngIf="modalState?.showOrderType">
            <div
              class="order-card"
              *ngFor="let item of orderType"
              (click)="orderTypeClicked(item)"
            >
              <img
                class="order-type-img"
                src="{{ item.img_src }}"
                [alt]="item.name"
              />
              <p
                class="order-type-text"
                *ngIf="
                  item.order_type !== 2 && item.order_type !== 0;
                  else localOrderType
                "
              >
                {{ item.name }}
              </p>
              <ng-template #localOrderType>
                <p class="order-type-text dine-in-takeaway">
                  <ng-container [ngSwitch]="item.order_type">
                    <ng-container *ngSwitchCase="0">{{
                      'POS.DINE_IN' | fallbackTranslate | titlecase
                    }}</ng-container>
                    <ng-container *ngSwitchCase="2">{{
                      'POS.TAKEAWAY' | fallbackTranslate | titlecase
                    }}</ng-container>
                  </ng-container>
                </p>
              </ng-template>
            </div>
          </div>

          <!-- Tk DL tags for offline platforms -->
          <div class="flex_se" *ngIf="modalState?.showPlatformOrderType">
            <div
              class="order-card"
              (click)="setPlatformOrderTypeClicked(1)"
              *ngIf="isPlatformTypeDel"
            >
              <img
                class="order-type-img"
                [src]="images.MAP"
                [alt]="currPlatform"
              />
              <p class="order-type-text">
                {{ currPlatform }} : {{ 'POS.DELIVERY' | fallbackTranslate }}
              </p>
            </div>
            <div
              class="order-card"
              (click)="setPlatformOrderTypeClicked(2)"
              *ngIf="isPlatformTypeTak"
            >
              <img
                class="order-type-img"
                [src]="images.LUNCH"
                [alt]="currPlatform"
              />
              <p class="order-type-text">
                {{ currPlatform }} : {{ 'POS.PICK_UP' | fallbackTranslate }}
              </p>
            </div>
          </div>
          <!-- Tk DL tags for offline platforms end -->

          <div *ngIf="modalState?.showEditPax">
            <div style="text-align: center">
              <input
                #calculator
                inputmode="none"
                type="text"
                placeholder="{{ 'POS.ENTER_HERE' | fallbackTranslate }}"
                class="input-pax-class"
                (keypress)="changes($event)"
                autocomplete="off"
                [(ngModel)]="defaultValue"
              />
            </div>

            <div class="calculator m-b-10 m-t-10">
              <app-virtual-keyboard
                (numberEntered)="getNumber($event)"
                (numBackClicked)="numBack($event)"
                [showDecimal]="false"
              ></app-virtual-keyboard>
            </div>

            <button class="save" (click)="savePaxClicked()">
              {{ 'POS.SAVE' | fallbackTranslate }}
            </button>
          </div>
          <!-- User Details -->
          <div *ngIf="modalState?.showCustomer">
            <div class="flex-row">
              <form nz-form [formGroup]="customerForm" class="wd-100">
                <div class="form-container">
                  <div
                    nz-row
                    [nzGutter]="8"
                    nzType="flex"
                    nzJustify="space-around"
                    nzAlign="middle"
                  >
                    <nz-form-item
                      nz-col
                      [nzXs]="{ span: 4 }"
                      [nzMd]="{ span: 4 }"
                      [nzLg]="{ span: 4 }"
                      [nzXl]="{ span: 4 }"
                    >
                      <label>
                        {{ 'POS.DIAL_CODE_LABEL' | fallbackTranslate }}
                      </label>

                      <nz-form-control>
                        <input
                          type="tel"
                          nz-input
                          nzSize="large"
                          placeholder="{{ 'POS.ENTER_DIAL_CODE' | fallbackTranslate }}"
                          class="input-name-class"
                          name="dial_code"
                          formControlName="dial_code"
                          (input)="checkInput($event, 'dial_code')"
                          minlength="2"
                          maxlength="5"
                          onkeypress="return (event.charCode !== 8 && event.charCode === 0 || (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 43)"
                        />
                        <!-- <p class="alert-text" *ngIf="customerForm.get('dial_code').hasError('required') && customerForm.get('dial_code').touched ">{{'VALIDATIONS.REQUIRED' | fallbackTranslate}}</p> -->
                      </nz-form-control>
                    </nz-form-item>

                    <nz-form-item
                      class="p-l-8"
                      nz-col
                      [nzXs]="{ span: 10 }"
                      [nzMd]="{ span: 10 }"
                      [nzLg]="{ span: 10 }"
                      [nzXl]="{ span: 10 }"
                    >
                      <label>
                        {{ 'POS.PHONE_NUMBER_LABEL' | fallbackTranslate }}
                      </label>
                      <nz-form-control
                        [nzValidateStatus]="
                          customerSearch?.numberValidityStatus
                        "
                      >
                        <nz-input-group
                          [nzPrefix]="prefixTemplateUser"
                        >
                          <input
                            type="tel"
                            nz-input
                            placeholder="{{ 'POS.ENTER_PHONE_NUMBER' | fallbackTranslate }}"
                            id="number"
                            class="customer-phone"
                            name="number"
                            maxlength="13"
                            (input)="checkInput($event, 'phone')"
                            onkeypress="return (event.charCode !== 8 && event.charCode === 0 || (event.charCode >= 48 && event.charCode <= 57))"
                            formControlName="number"
                          />
                        </nz-input-group>
                        <ng-template #prefixTemplateUser>
                          <i nz-icon nzType="search"></i>
                        </ng-template>
                      </nz-form-control>
                       <span class="error" *ngIf="isPhoneNumLength13Chars">  {{ 'POS.CANT_EXCEED_13_DIGITS' | fallbackTranslate }} </span>
                       <span class="error" *ngIf="
                       customerForm
                         ?.get(['number'])
                         ?.invalid
                     ">  Please enter phone number </span>
                    </nz-form-item>

                    <nz-form-item
                      class="p-l-8"
                      nz-col
                      [nzXs]="{ span: 10 }"
                      [nzMd]="{ span: 10 }"
                      [nzLg]="{ span: 10 }"
                      [nzXl]="{ span: 10 }"
                    >
                      <label>
                        {{ 'POS.CUSTOMER_NAME' | fallbackTranslate }}
                      </label>
                      <nz-form-control
                        [nzValidateStatus]="customerSearch?.nameValidityStatus"
                      >
                        <input
                          type="text"
                          nzSize="large"
                          nz-input
                          [placeholder]="customerSearch?.namePlaceHolder"
                          id="name"
                          class="input-name-class"
                          name="name"
                          formControlName="name"
                          (input)="checkInput($event, 'name')"
                          [disabled]="fetchedUserData.name != ''"
                          [readonly]="fetchedUserData.name != ''"
                          onkeypress="return (event.charCode !== 8 && event.charCode === 0 || ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <=122) || event.charCode === 32))"
                        />
                      </nz-form-control>
                    </nz-form-item>
                  </div>

                  <div
                    class="form-group"
                    class="form-input-container"
                    *ngIf="this.selectedOrder.platform == 'others'"
                  >
                    <div class="form-area">
                      <label>
                        {{ 'POS.ENTER_ORDERING_PLATFORM_NAME' | fallbackTranslate }}
                      </label>
                      <input
                        type="text"
                        nzSize="large"
                        nz-input
                        placeholder="{{ 'POS.ENTER_HERE' | fallbackTranslate }}"
                        id="address"
                        class="input-name-class"
                        name="address"
                      />
                    </div>
                  </div>
                </div>
                <div
                  nz-row
                  [nzGutter]="8"
                  nzType="flex"
                  nzJustify="space-around"
                  nzAlign="middle"
                  class="fo"
                  nzSize="large"
                >
                  <nz-form-item
                    nz-col
                    [nzXs]="{ span: 14 }"
                    [nzMd]="{ span: 14 }"
                    [nzLg]="{ span: 14 }"
                    [nzXl]="{ span: 14 }"
                  >
                    <label>
                      {{ 'POS.GENDER' | fallbackTranslate }}
                    </label>
                    <nz-form-control
                      [nzValidateStatus]="customerSearch?.genderValidityStatus"
                    >
                      <div class="gendercls">
                        <nz-radio-group
                          formControlName="user_gender"
                          class="wd-100 gender-container"
                          [nzDisabled]="fetchedUserData?.gender !== ''"
                        >
                          <label
                            *ngFor="let item of gender ; let i=index;" ngClass="width-level-{{i}}"
                            nz-radio
                            [nzValue]="item?.id"
                            >{{ item?.label }}</label
                          >
                        </nz-radio-group>
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                  <nz-form-item
                    nz-col
                    [nzXs]="{ span: 10 }"
                    [nzMd]="{ span: 10 }"
                    [nzLg]="{ span: 10 }"
                    [nzXl]="{ span: 10 }"
                  >
                    <label>
                      {{ 'POS.CUST_DOB' | fallbackTranslate }}
                    </label>
                    <nz-form-control
                      [nzValidateStatus]="customerSearch?.dobValidityStatus"
                      class="wd-100"
                    >
                      <nz-date-picker
                        [(ngModel)]="currentDate"
                        name="user_dob"
                        [nzDisabledDate]="disabledDate"
                        formControlName="user_dob"
                        nzSize="large"
                        nzPlaceHolder="yyyy-mm-dd"
                        [nzDisabled]="fetchedUserData?.DOB !== '' && fetchedUserData?.DOB !== null"
                        [nzDisabledDate]="disableFutureDates"
                        >
                      </nz-date-picker>
                    </nz-form-control>
                  </nz-form-item>

                  <div
                    class="form-group"
                    class="form-input-container"
                    *ngIf="this.selectedOrder.platform == 'others'"
                  >
                    <div class="form-area">
                      <label>
                        {{ 'POS.ENTER_ORDERING_PLATFORM_NAME' | fallbackTranslate }}
                      </label>
                      <input
                        type="text"
                        nzSize="large"
                        nz-input
                        placeholder="{{ 'POS.ENTER_HERE' | fallbackTranslate }}"
                        id="address"
                        class="input-name-class"
                        name="address"
                      />
                    </div>
                  </div>
                </div>
                <div *ngIf="showSpecialFieldInUserForm" nz-row [nzGutter]="8" nzType="flex" nzJustify="space-between" nzAlign="middle" class="m-b-20">
                  <nz-form-item class="m-0" nz-col [nzXs]="{ span: 10 }" [nzMd]="{ span: 10 }" [nzLg]="{ span: 10 }" [nzXl]="{ span: 10 }">
                    <nz-form-control>
                      <label>
                        NRIC Category
                      </label>
                      <nz-select nzSize="large" class="wd-100" nzPlaceHolder="Select Category" nzShowSearch formControlName="special_category">
                        <nz-option *ngFor="let option of special_category" [nzLabel]="option.name" [nzValue]="option.id">
                        </nz-option>
                      </nz-select>
                      <ng-template #prefixTemplateUser>
                        <i nz-icon nzType="search"></i>
                      </ng-template>
                    </nz-form-control>
                    <div class="error" *ngIf="
                    customerForm
                      ?.get(['special_category'])
                      ?.invalid
                  ">
                  Please Select Category
                </div>
                  </nz-form-item>
                
                  <nz-form-item class="m-0" nz-col [nzXs]="{ span: 10 }" [nzMd]="{ span: 10 }" [nzLg]="{ span: 10 }"
                    [nzXl]="{ span: 10 }">
                    <nz-form-control>
                      <nz-input-group nzSize="large">
                        <label>
                          IC Number
                        </label>
                        <input type="text" nz-input placeholder="Enter IC Number" id="unique-id" class="input-unique-id-class" name="unique-id" maxlength="12"
                          (input)="checkInput($event, 'unique-id')"
                          onkeypress="return (event.charCode !== 8 && event.charCode === 0 || (event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))"
                          formControlName="unique_id" />
                        </nz-input-group>
                      </nz-form-control>
                      <div class="error" *ngIf="
                        customerForm
                          ?.get(['unique_id'])
                          ?.invalid
                      ">
                      Please enter valid 12 digit IC Number
                    </div>
                  </nz-form-item>
                </div>
                <div
                  nz-row
                  nzType="flex"
                  nzAlign="middle"
                  class="loyality-info-container"
                >
                <img
                [src]="images.LOYALITY_CUSTOMER"
                alt="loyality"
                />
                 <p> {{ 'POS.KNOWING_CUSTOMER_MAKE_DAY_BETTER' | fallbackTranslate }}</p>
                </div>
              </form>
            </div>
            <div *ngIf="this.doesUserIdExist === false" class="user-error">
              * {{ 'POS.USER_NOT_REGISTERED' | fallbackTranslate }}
            </div>
            <div
              class="spinner-container-loyalty"
              *ngIf="this.isLoyaltyLoading"
            >
              <ng-template #indicatorTemplate
                ><i nz-icon nzType="loading"></i
              ></ng-template>
              <nz-spin nzSimple [nzIndicator]="indicatorTemplate"> </nz-spin>
            </div>
            <div class="loyalty__container" *ngIf="this.showLoyaltyCashback">
              <div class="modal-information loyalty-header">
                <span nz-typography class="fs-14 fw-600">
                  {{ 'POS.LOYALTY_CASHBACK' | fallbackTranslate }}
                </span>
              </div>
              <div class="loyalty__price-container">
                <div class="loyalty__price-info">
                  {{ 'POS.LOYALTY_CASHBACK_AVAILABLE' | fallbackTranslate }}:
                  <span class="loyalty__price-value"
                    >{{ Currency }}
                    {{ loyaltyCashback?.total_credits_text }}</span
                  >
                </div>
              </div>
              <div class="loyalty__checkbox-container">
                <input
                  nz-tooltip 
                  [nzTooltipTitle]="loyaltyTooltipText"
                  type="checkbox"
                  class="loyalty__checkbox"
                  [checked]="this.applyCashbackChecked"
                  (change)="this.handleCashbackCheckbox($event)"
                  [disabled]="this.loyaltyCashback.total_credits === 0 || this.disableLoyaltyCheckbox"
                />
                <div class="loyalty__checkbox-label">
                  {{ 'POS.LOYALTY_CASHBACK_APPLY' | fallbackTranslate }}
                </div>
              </div>
              <div class="loyalty-error" *ngIf="loyaltyErrorCondition">*{{'POS.ADD_ITEMS_WORTH' | fallbackTranslate}} {{Currency}} {{loyaltyAmtReq}} {{'POS.MORE_TO_APPLY' | fallbackTranslate}}</div>
            </div>
            <button
              class="save"
              (click)="userDetailsClicked()"
              [disabled]="
                this.isLoyaltyLoading ||
                this.isApiRequestLoading ||
                (this.data.isApplyCashbackClicked &&
                  (!this.applyCashbackChecked ||
                    this.loyaltyCashback.total_credits === 0 ||
                    !this.doesUserIdExist)) || (isKiosk && isKioskUserDetailsNotValid())
                    || (customerForm.get('unique_id').invalid || customerForm.get('special_category').invalid)
              "
              nz-button
              [nzLoading]="this.isApiRequestLoading"
            >
              {{
                (((customerForm.get('number').value.length === 0 ||
                  customerForm.get('number').value.length > 8) &&
                  customerForm.get('name').value.length > 0) ||
                isKiosk
                  ? 'POS.SAVE'
                  : 'POS.SKIP'
                ) | fallbackTranslate
              }}
            </button>
          </div>
          <!-- Table Select -->
          <div
            class="mb-20 tables-parent-container"
            *ngIf="modalState?.showTable"
          >
            <ng-container *ngIf="!fetchingTablesData; else loading">
              <nz-select [(ngModel)]="selectedSection" (ngModelChange)="getTablesData()" class="section-dropdown m-l-10" nzSize="large">
                <nz-option *ngFor="let section of availableFloors" [nzValue]="section?.floor_id"
                  (click)="changeFloor(section?.floor_id, section?.floor_name)" [nzLabel]="section?.floor_name">
                </nz-option>
              </nz-select>
              <div class="table-row">
                <button
                  class="table-card"
                  *ngFor="let item of selectedFloorTables"
                  (click)="tableClicked(item?.table_no, item?.table_id)"
                  [ngClass]="{
                    'table-active':
                      isTransferTable && currentTableId === item?.table_id
                  }"
                >
                  {{ item?.table_no }}
                </button>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="footer" *ngIf="isTransferTable">
          <button
            class="save"
            (click)="transferTable_clicked()"
            [disabled]="
              currentTableId == data.tableData.tableid || buttonClicked
            "
          >
            {{ 'POS.TRANSFER_TABLE' | fallbackTranslate }}
          </button>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="dynamicQrTemplate"></ng-container>
    </div>
  </div>
</div>

<!-- Generic loader template; can be used while records are fetched... -->
<ng-template #loading>
  <div class="spinner-container">
    <ng-template #indicatorTemplate>
      <i nz-icon nzType="loading" style="font-size: 30px"></i>
    </ng-template>
    <nz-spin nzSimple [nzIndicator]="indicatorTemplate"></nz-spin>
  </div>
</ng-template>

<ng-template #dynamicQrTemplate>
  <div class="dynamic-qr-detail p-l-16 p-r-16 p-b-16 p-t-6" *ngIf="dynamicQrObj?.showDynamicQrSetting">
    <form  class="flex_coloumn" [formGroup]="dynamicQrForm">
      <div  class="flex p-t-5  p-b-16 justify-content-between">
        <div class="fw-600 fs-20 clr-333">
          {{ 'POS.QR_VALID_FOR' | fallbackTranslate }}
        </div>
        <div class="flex gap-4">
          <div class="flex flex_column">
            <input type="number" formControlName="dynamicQrValidityTime" class="ta_center p-t-4 p-b-4 dynamic-qr-box-input"  (input)="handleQrValidityInput($event)"/>
          </div>
          <div class="margin-top-5 line-separator"></div>
          <div class="flex">
            <nz-radio-group formControlName="dynamicQrTimeMeasure">
              <label *ngFor="let time of dynamicQrObj?.timeValidity; trackBy: trackById" nz-radio [nzValue]="time?.id"
                >{{ time?.label }}</label>
            </nz-radio-group>
          </div>
        </div>
      </div>
      <div class="flex_sb p-r-18">
        <div class="flex_coloumn">
          <div class="fs-16 clr-666">{{ 'POS.PRINT_QR_FOR_TABLE_NO' | fallbackTranslate }}</div>
          <div class="fs-20 fw-600 clr-333">{{currentTableNo}}</div>
        </div>
        <button class="print-qr-btn fs-16 fw-700" (click)="printDynamicQr()">
          {{'POS.PRINT_QR' | fallbackTranslate}}
        </button>
      </div>
    </form>
  </div>
</ng-template>